<template>
  <div
    class="billing-input"
    :class="{'redesign': isOnboardingRedesign}"
  >
    <div
      class="accordion"
      role="tablist"
      :class="isOnboardingRedesign ? 'tw-max-w-[600px] tw-mx-auto' : ''"
    >
      <b-card
        no-body
      >
        <div
          :aria-expanded="isCreditOrDebitVisible ? 'true' : 'false'"
          aria-controls="accordion-1"
          header-tag="header"
          role="tab"
          class="d-flex payment-option"
          @click="isCreditOrDebitVisible = !isCreditOrDebitVisible"
        >
          <div>
            <span
              v-if="isCreditOrDebitVisible"
              class="when-opened"
            >
              <b-avatar
                :variant="isOnboardingRedesign ? 'primary' : 'tertiary'"
                size="22px"
              >
                <b-icon
                  icon="check"
                  font-scale="1.2"
                  :style="isOnboardingRedesign ? 'color: #ffffff' : 'color: #cdfcb1'"
                />
              </b-avatar>
            </span>
            <span
              v-else
              class="when-closed"
            >
              <b-avatar
                style="background-color: #e0e0e0"
                icon="chevron-up"
                size="22px"
              >
                <b-icon
                  icon="circle-fill"
                  font-scale="1.2"
                  style="color: #e0e0e0"
                />
              </b-avatar>
            </span>
          </div>
          <div
            class="payment-title"
            style="flex-grow: 1"
          >
            Credit or Debit Card
          </div>
          <div
            class="tw-flex"
          >
            <img
              src="@/assets/images/payment-methods/jcb.svg"
              width="20px"
            >
            <img
              src="@/assets/images/payment-methods/visa.svg"
              width="20px"
            >
            <img
              src="@/assets/images/payment-methods/mastercard.svg"
              width="20px"
            >
          </div>
        </div>
        <b-collapse
          id="accordion-1"
          v-model="isCreditOrDebitVisible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body
            v-if="['J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
            class="elements-container"
          >
            <div
              ref="card"
            >
              <!-- A Stripe Element will be inserted here. -->
            </div>
          </b-card-body>
          <b-card-body v-else>
            <b-row>
              <b-col>
                <div
                  ref="card"
                  class="form-control m-2"
                >
                  <!-- A Stripe Element will be inserted here. -->
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card
        v-show="canMakePayment"
        no-body
      >
        <div
          :aria-expanded="isPayWithVisible ? 'true' : 'false'"
          aria-controls="accordion-2"
          header-tag="header"
          role="tab"
          class="d-flex payment-option"
          @click="isPayWithVisible = !isPayWithVisible"
        >
          <div>
            <span
              v-if="isPayWithVisible"
              class="when-opened"
            >
              <b-avatar
                :variant="isOnboardingRedesign ? 'primary' : 'tertiary'"
                size="22px"
              >
                <b-icon
                  icon="check"
                  font-scale="1.2"
                  :style="isOnboardingRedesign ? 'color: #ffffff' : 'color: #cdfcb1'"
                />
              </b-avatar>
            </span>
            <span
              v-else
              class="when-closed"
            >
              <b-avatar
                style="background-color: #e0e0e0"
                icon="chevron-up"
                size="22px"
              >
                <b-icon
                  icon="circle-fill"
                  font-scale="1.2"
                  style="color: #e0e0e0"
                />
              </b-avatar>
            </span>
          </div>
          <div
            class="payment-title"
            style="flex-grow: 1"
          >
            {{ paymentLabel }}
          </div>
          <div
            class="tw-flex"
          >
            <img
              src="@/assets/images/payment-methods/apple-pay.svg"
              width="20px"
            >
            <img
              src="@/assets/images/payment-methods/google-pay.svg"
              width="20px"
            >
          </div>
        </div>
        <b-collapse
          id="accordion-2"
          v-model="isPayWithVisible"
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-row>
              <b-col>
                <PaymentMethod
                  :class="{'md:tw-max-w-[300px] tw-mx-auto tw-w-full !tw-pt-0': isOnboardingRedesign, 'tw-pt-4': !isOnboardingRedesign}"
                  :total-price="totalPrice"
                  @success="onPaymentMethodSuccess"
                  @canMakePayment="canMakePayment = $event"
                />
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
    <b-row
      v-if="['F2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant)"
      class="tw-max-w-[600px] tw-mx-auto tw-mt-8"
    >
      <b-col cols="12">
        <b-form-checkbox
          v-model="sameaddress"
          class="mt-3 mb-3 checkbox-label"
          value="true"
          unchecked-value="false"
        >
          My billing information is the same as my shipping information.
        </b-form-checkbox>
        <hr class="tw-border-[#C7C7C7]">
        <div
          v-if="isOnboardingRedesign"
          class="checkout-agreement tw-mt-2"
        >
          <p class="tw-text-sm tw-text-[#929292]">
            By adding a payment method and clicking "Submit," you're agreeing to opt into a subscription with Winona. However, you won't be charged unless your physician prescribes a treatment plan. If prescribed, your payment method will be charged at that time for the cost of your prescription(s). Your subscription will renew every month or every 3 months, depending on your selection. You can cancel your subscription at any time.
          </p>
        </div>
        <BillingAddress
          v-if="sameaddress != 'true'"
          ref="addressComponent"
          class="mt-5"
        />
      </b-col>
    </b-row>
    <b-row
      v-else
      :class="{'tw-max-w-[600px] tw-mx-auto': ![null, 'A', 'B', 'C'].includes(onboardingVariant)}"
    >
      <b-col cols="12">
        <b-form-checkbox
          v-model="sameaddress"
          class="mt-3 mb-3 checkbox-label"
          value="true"
          unchecked-value="false"
        >
          My billing information is the same as my shipping information.

          <div
            v-if="isOnboardingRedesign"
            class="checkout-agreement tw-mt-2"
          >
            <p class="tw-text-sm tw-text-[#929292]">
              By adding a payment method and clicking "Submit," you're agreeing to opt into a subscription with Winona. However, you won't be charged unless your physician prescribes a treatment plan. If prescribed, your payment method will be charged at that time for the cost of your prescription(s). Your subscription will renew every month or every 3 months, depending on your selection. You can cancel your subscription at any time.
            </p>
          </div>
        </b-form-checkbox>
        <BillingAddress
          v-if="sameaddress != 'true'"
          ref="addressComponent"
          class="mt-5"
        />
      </b-col>
    </b-row>

    <div
      v-if="!isOnboardingRedesign"
      class="checkout-agreement tw-mt-6"
    >
      <p class="tw-text-sm">
        By adding a payment method and clicking "Submit," you're agreeing to
        opt into a subscription with Winona. However, you won't be charged
        unless your physician prescribes a treatment plan. If prescribed,
        your payment method will be charged at that time for the cost of
        your prescription(s). Your subscription will renew every month or
        every 3 months, depending on your preference. Please note you can
        cancel your subscription and stop receiving treatment at any time,
        by contacting the Patient Care Team.
      </p>
    </div>

    <OnboardingCTAContainer>
      <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full slight-rounded">
        <div>
          <b-button
            pill
            block
            variant="info"
            :disabled="disabled"
            class="slight-rounded"
            :class="{
              'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign && onboardingVariant !== 'F2',
              'tw-max-w-[350px] tw-mx-auto tw-text-base md:tw-text-lg !tw-px-2 md:!tw-px-0': isOnboardingRedesign && onboardingVariant === 'F2',
            }"
            @click="checkAnswers({ paymentmethodid: null })"
          >
            {{ onboardingVariant === 'F2' ? 'Submit for doctor review' : 'Submit' }}
          </b-button>
        </div>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// components
import BillingAddress from '@/components/onboarding/checkout/BillingAddress';
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import PaymentMethod from '@/components/onboarding/checkout/PaymentMethod.vue';

// services
import { PatientService } from '@/services/patient.service';
import { LookUpService } from '@/services/lookup.service';

export default {
  components: {
    OnboardingCTAContainer,
    BillingAddress,
    PaymentMethod
  },
  props: {
    body: {
      type: Object,
      default: () => ({}),
    },
    totalPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pk: process.env.VUE_APP_STRIPE_CLIENT_KEYS,
      stripe: undefined,
      card: undefined,
      discountcode: '',
      sameaddress: 'true',
      loading: false,
      states: [],
      total: 0,
      footerarray: [],
      disabled: false,
      isCreditOrDebitVisible: true,
      isPayWithVisible: false,
      canMakePayment: false,
      confirmedPaymentMethod: null,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    paymentLabel() {
      return this.isOnboardingRedesign && this.onboardingVariant !== 'D1'
        ? 'Express Checkout'
        : 'Pay with';
    }
  },
  watch: {
    isCreditOrDebitVisible(val, prevVal) {
      if (this.isPayWithVisible === false && prevVal === true) {
        this.isCreditOrDebitVisible = true;
      }
    },
    isPayWithVisible(val, prevVal) {
      if (this.isCreditOrDebitVisible === false && prevVal === true) {
        this.isPayWithVisible = true;
      }

      if (val) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    async totalPrice(newVal) {
      if (newVal > 0 && !this.stripe) {
        await this.loadStripe();
      }
    },
  },
  async mounted () {
    this.loadStates();
    
    await this.loadStripe();

    if (this.body.hasOwnProperty('desiredplan')) {
      for (const plan of this.body.desiredplan) {
        let subscription = '';
        if (plan.pricingdetail.type == 'recurring') {
          if (plan.pricingdetail.recurring.interval_count == '90') {
            subscription = '3 months';
          } else if (plan.pricingdetail.recurring.interval_count == '30') {
            subscription = 'monthly';
          }
        }

        const notes = `If prescribed ${plan.name}, you are enrolling in a ${subscription} subscription for $${plan.price}.`;
        this.footerarray.push(notes);
      }
      this.footerarray.push('You can cancel your subscription(s) at any time.');
    }
    if (this.body.hasOwnProperty('desiredaddon')) {
      for (const addon of this.body.desiredaddon) {
        this.total += addon.price;
        if (!['J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingVariant)) {
          this.$emit('update-total', addon.price);
        }
      }
    }
    if (this.body.hasOwnProperty('couponid')) {
      this.discountcode = this.body.couponid;
      // Add discount context
      this.footerarray.push(
        'A discount code is only applied to the first prescription and not the subsequent subscriptions.'
      );
    }
  },
  methods: {
    async loadStripe() {
      this.stripe = Stripe(this.pk);

      if (['J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingVariant)) {
        const { data } = await PatientService.getStripeSetupIntentClientSecret()

        const appearance = {};
        const options = { 
          wallets: {
            applePay: 'never',
            googlePay: 'never',
          },
          fields: {
            billingDetails: {
              address: 'never',
            }
          }
        };
        const elements = this.stripe.elements({ clientSecret: data.body.client_secret, appearance })
        this.card = elements
        const paymentElement = elements.create('payment', options);
        paymentElement.mount(this.$refs.card);
      } else {
        this.card = this.stripe.elements().create('card', {
          hidePostalCode: true,
        });
        this.card.mount(this.$refs.card);
      }
    },
    async loadStates() {
      const { data } = await LookUpService.getLookUp('state');
      this.states = data;
    },
    async checkAnswers({ paymentmethodid }) {
      this.disabled = true;
      let formattedAnswer;
      // * Pre-formats answer
      if (this.sameaddress == 'true') {
        formattedAnswer = {
          source: '',
          sameaddress: true,
        };
      } else {
        const billingaddress = {
          ...this.$refs.addressComponent.billingaddress,
        };

        if (
          !billingaddress.address1 ||
          !billingaddress.city ||
          !billingaddress.state ||
          !billingaddress.zipcode ||
          !billingaddress.phoneno
        ) {
          this.$emit(
            'showAlert',
            'Please complete the billing address fields.'
          );
          this.disabled = false;
          return;
        }

        formattedAnswer = {
          source: '',
          sameaddress: false,
          billingaddress: billingaddress,
        };

        if (formattedAnswer.billingaddress.address2 == null) {
          delete formattedAnswer.billingaddress['address2'];
        }

        formattedAnswer.billingaddress.state = this.states.filter(
          state =>
            state.name == this.$refs.addressComponent.billingaddress.state
        )[0].id;
      }

      if (paymentmethodid) {
        delete formattedAnswer.source;
        formattedAnswer.paymentmethod = paymentmethodid;
      }

      try {
        if (formattedAnswer.paymentmethod) {
          this.$emit('nextStep', formattedAnswer, this.total);
          this.loading = true;
        } else {
          this.$emit('hideAlert');
          
          if (['J', '1225-onboarding-core-v1', 'K'].includes(this.onboardingVariant)) {
            if (!this.confirmedPaymentMethod) {
              const { error, setupIntent } = await this.stripe.confirmSetup({
                elements: this.card,
                confirmParams: {
                  return_url: window.location.origin + '/checkout/complete',
                  payment_method_data: {
                    billing_details: {
                      address: {
                        country: 'US',
                        postal_code: formattedAnswer.sameaddress ? this.body.zipcode : formattedAnswer.billingaddress.zipcode,
                        state: formattedAnswer.sameaddress ? this.body.state : formattedAnswer.billingaddress.state,
                        city: formattedAnswer.sameaddress ? this.body.city : formattedAnswer.billingaddress.city,
                        line1: formattedAnswer.sameaddress ? this.body.address1 : formattedAnswer.billingaddress.address1,
                        line2: formattedAnswer.sameaddress ? this.body.address2 : formattedAnswer.billingaddress.address2,
                      }
                    }
                  }
                },
                redirect: 'if_required',
              });

              if (error) {
                if (error.type === 'card_error' || error.type === 'validation_error') {
                  this.$emit('showAlert', error.message);
                } else {
                  this.$emit('showAlert', error.message || 'Setup confirmation failed');
                }
                this.disabled = false;
                return;
              }

              this.confirmedPaymentMethod = setupIntent.payment_method;
            }

            // Payment method saved successfully
            formattedAnswer.paymentmethod = this.confirmedPaymentMethod;
            formattedAnswer.source = 'card';
          } else {
            const token = await this.stripe.createToken(this.card);
            if (token.error) {
              this.$emit('showAlert', token.error.message);
              this.disabled = false;
              return;
            }
            formattedAnswer.source = token.token.id;
          }

          this.$emit('nextStep', formattedAnswer, this.total);
          this.loading = true;
        }
      } catch (err) {
        this.$emit('showAlert', err.message || err);
        this.disabled = false;
        this.loading = false;
      } finally {
        this.disabled = false;
        this.loading = false;
      }
    },
    onPaymentMethodSuccess(stripeEvent) {
      const paymentMethodId = typeof stripeEvent.paymentMethod === 'string' 
        ? stripeEvent.paymentMethod 
        : stripeEvent.paymentMethod?.id;
      
      if (!paymentMethodId) {
        console.error('No payment method ID found in event:', stripeEvent);
        this.$emit('showAlert', 'Payment method ID is missing');
        return;
      }
      
      this.checkAnswers({ paymentmethodid: paymentMethodId });
    },
  },
};
</script>

<style lang="scss" scoped>
.discount-btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #cdfcb1;
  background-color: #b293ff;
  border-color: #b293ff;
  text-decoration: none;
}

.badge-tertiary {
  background-color: $tertiary;
}

.accordion > .card {
  border-bottom: 1px solid #edf2f9;
  margin-bottom: 1rem;
}

.redesign {
  .accordion > .card {
    border: 1px solid #C7C7C7;
    border-radius: 0.75rem;
    margin-bottom: 1rem;
    transition: border-color 0.2s ease;
    
    &:has(.collapse.show) {
      border-color: #1A6A72;
    }
  }
}

.collapsed .when-opened,
.not-collapsed .when-closed {
  display: none;
}

.collapse.show,
.not-collapsed {
  background-color: #f9f9f9;
}

.redesign {
  .collapse.show,
  .not-collapsed {
    background-color: #ffffff;
  }
}

.payment-option {
  padding: 8px 12px;
  outline: none;
  cursor: pointer;

  @include media-breakpoint-up(xxl) {
    padding: 8px * $scale-font 12px * $scale-font;
  }

  .payment-title {
    padding-left: 13px;

    @include media-breakpoint-up(xxl) {
      padding-left: 13px * $scale-font;
    }
  }
}

img {
  margin-left: 5px;
  width: 35px;
  @include media-breakpoint-down(md) {
    width: 20px;
  }
}

.checkout-agreement {
  ul {
    list-style-type: none;
    li::marker {
      content: "-";
    }
    li {
      padding-left: 30px;
    }
    padding-left: 5px;
  }
}

.elements-container {
  min-height: 200px;
  height: auto;
  
  > div {
    min-height: 200px;
  }
}
</style>
